<template>
  <el-table :data="table" height="300" style="width: 100%">
    <el-table-column prop="公司" label="公司名称">
      <template slot-scope="scope">
        <span style="color:#409eff;cursor:pointer;" @click="showmapping(scope.row._id)">{{ scope.row.公司 }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="部门" label="部门"> </el-table-column>
    <el-table-column prop="日期" label="日期"> </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    table: { type: Array, default: () => [] },
  },
  data() {
    return {}
  },
  methods: {
    showmapping(id) {
      app.root.$refs.mappingOchart.open(id)
    },
  },
}
</script>
